<section class="dz-text-14 dz-text-align-right padding-top-object-2 model-table">
	<section class="dz-row text-bold padding-vertical-object-4 header-row" *ngIf="tableData && tableData[0]">
		<div class="dz-col-24 dz-flex table-header">
			<div data-cy="model-name-header" [class]="mainColumnWidth" class="dz-text-align-left">
				<span class="dz-text-14-bold" dcrHTMLKey="MODEL_NAME_HEADER">Model Name</span>
				<p *ngIf="showModelsComparisonStats" class="color-gray-light dz-text-sm-14 dz-text-lg-12 padding-top-object-1 subheader-text" dcrHTMLKey="MODEL_NAME_SUBHEADER">
					Select to compare
				</p>
			</div>
			<ng-container *ngFor="let riskProfileKey of riskProfileKeys">
				<ng-template [ngTemplateOutlet]="riskProfileKeyHeader" [ngTemplateOutletContext]="{ riskProfileKey: riskProfileKey }"></ng-template>
			</ng-container>
			<div class="dz-col-2 dz-hidden dz-inline-block-lg" dcrHTMLKey="ACTION_HEADER" *ngIf="showAnalysisButton">Analyze</div>
		</div>
	</section>
	<ng-container *ngIf="(riskBasedModelGroups | keyvalue)?.length; else noData">
		<ng-container *ngIf="!isAuthenticated">
			<div class="sign-in">
				<button dz-button (click)="authenticateUser()">
					<dz-icon type="lock" class="color-blk-orange dz-text-14 padding-object-2"></dz-icon><span dcrHTMLKey="SIGN_IN_BUTTON">Sign In</span>
				</button>
			</div>
		</ng-container>
		<section data-cy="models-list" class="dz-hidden dz-block-md dz-row margin-top-30" *ngFor="let riskGroupKey of RISK_PROFILE_SORT_ORDER; let groupsIdx = index">
			<ng-container *ngIf="riskBasedModelGroups[riskGroupKey] && riskBasedModelGroups[riskGroupKey][0]">
				<div class="dz-col-24">
					<div data-cy="model-row" class="dz-row border-bottom" *ngFor="let groupedRow of riskBasedModelGroups[riskGroupKey]; first as isFirst; last as isLast">
						<div [class]="mainColumnWidth" class="dz-text-align-left model-desp-risk-profile-container dz-justify-content-left dz-justify-content-between-lg dz-col">
							<div
								[ngClass]="{
									'padding-top-0 padding-bottom-15': isFirst,
									'padding-bottom-0 padding-top-object-4': isLast,
									'padding-vertical-object-4': !isLast && !isFirst
								}"
								class="margin-right-object-1 dz-flex dz-justify-content-evenly dz-align-items-center dz-align-items-top-lg padding-vertical"
							>
								<dz-checkbox
									*ngIf="showModelsComparisonStats"
									[disabled]="selectedModelIds.length >= 3 && selectedModelIds.indexOf(groupedRow?.portfolioId?.toString() || groupedRow?.id?.toString()) === -1"
									[checked]="selectedModelIds.indexOf(groupedRow?.portfolioId?.toString() || groupedRow?.id?.toString()) >= 0"
									(change)="selectedModelsChanged.emit({ rowData: groupedRow, checked: $event.checked, riskGroupKey: riskGroupKey })"
									custom-tracking
									[track-event]="
										tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME +
										':' +
										tealiumConstants.MODELS_EXPERIENCE_EVENTS.FIND_AND_COMPARE_PAGE +
										':modelId:' +
										groupedRow?.id.rawValue +
										':riskProfile:' +
										riskGroupKey +
										':checked:' +
										(selectedModelIds.indexOf(groupedRow?.portfolioId?.toString() || groupedRow?.id?.toString()) >= 0 ? 'false' : 'true')
									"
								>
								</dz-checkbox>
								<span
									*ngIf="!showFamilyDescription"
									class="hover-underline hover-pointer dz-text-14-bold dz-text-lg-14 padding-right-object-2"
									(click)="redirectTo360(!shouldUseDasPortfolioId ? groupedRow?.id.formattedValue : groupedRow?.dasPortfolioId.formattedValue)"
								>
									{{
										groupId !== sharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP && groupedRow?.modelExternalName?.formattedValue
											? groupedRow?.modelExternalName?.formattedValue
											: groupedRow?.description
									}}
								</span>
								<span *ngIf="showFamilyDescription">{{ description }}</span>
							</div>
							<mb-risk-profile-indicator *ngIf="showRiskIndicator" [riskGroupKey]="riskGroupKey"></mb-risk-profile-indicator>
						</div>
						<ng-container>
							<div [class]="columnWidth" *ngFor="let riskProfileKey of riskProfileKeys">
								<div
									[ngClass]="{
										'padding-top-0 padding-bottom-object-4': isFirst,
										'padding-bottom-0 padding-top-object-4': isLast,
										'padding-vertical-object-4': !isLast && !isFirst,
										'public-data-view': !isAuthenticated
									}"
									class="padding-vertical-object-4 dz-text-align-left dz-text-align-right-lg row-item padding-vertical"
								>
									<ng-template [ngTemplateOutlet]="riskProfileKeyHeader" [ngTemplateOutletContext]="{ riskProfileKey: riskProfileKey }"></ng-template>
									<ng-container *ngIf="!isAuthenticated; else modelDataTemplate">
										<span>X.XX%</span>
									</ng-container>
									<ng-template #modelDataTemplate>
										<span *ngIf="riskProfileKey !== 'riskProfile'">{{ groupedRow[riskProfileKey] }}</span>
										<span *ngIf="riskProfileKey === 'riskProfile'">{{ groupedRow?.modelShortName?.rawValue }}</span>
									</ng-template>
								</div>
							</div>
							<div class="dz-col-2 dz-hidden dz-inline-block-lg" *ngIf="showAnalysisButton" [ngClass]="{ 'actions-drawer-public-view': !isAuthenticated }">
								<div
									[ngClass]="{
										'padding-top-0 padding-bottom-object-4': isFirst,
										'padding-bottom-0 padding-top-object-4': isLast,
										'padding-vertical-object-4': !isLast && !isFirst
									}"
								>
									<mb-actions-drawer
										[portfolioId]="!shouldUseDasPortfolioId ? groupedRow?.id.formattedValue : groupedRow?.dasPortfolioId.formattedValue"
										[category]="category"
										[familyType]="familyType"
										[familyId]="familyId"
									></mb-actions-drawer>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
		</section>
	</ng-container>
</section>

<ng-template #noData>
	<mb-model-list-empty-container
		titleDCR="MODELS_ERROR_OCCURRED"
		[subTextDCR]="modelData[0]?.riskProfile?.formattedValue ? 'MODEL_LIST_NO_DATA' : 'MODEL_LIST_MISSING_RISK_PROFILE'"
	></mb-model-list-empty-container>
</ng-template>

<ng-template #riskProfileKeyHeader let-riskProfileKey="riskProfileKey">
	<ng-container [ngSwitch]="riskProfileKey">
		<ng-container *ngSwitchCase="'riskProfile'">
			<div [class]="headerWidth" class="no-padding riskProfileKeyHeader">
				<span dcrHTMLKey="RISK_PROFILE_HEADER">Risk Profile</span>
				<icon *ngIf="isAuthenticated" type="info-circle" class="info-circle" tooltip-dcr="HOLDINGS_RISK_PROFILE_TOOLTIP"></icon>
				<p class="color-gray-light dz-text-11 dz-text-lg-12 padding-top-object-1">
					<span dcrHTMLKey="tableData[0]?.riskProfile?.config?.label?.key">{{ tableData[0]?.riskProfile?.config?.label?.defaultText }} </span>
					<span dcrHTMLKey="HOLDINGS_RISK_PROFILE_SUBHEADER">(Growth / Defensive)</span>
				</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="'expenseRatio'">
			<div [class]="headerWidth" class="no-padding riskProfileKeyHeader">
				<span dcrHTMLKey="NET_EXPENSE_RATIO_HEADER">Net Expense Ratio</span>
				<icon *ngIf="isAuthenticated" type="info-circle" class="info-circle" tooltip-dcr="HOLDINGS_NET_EXP_RATIO_TOOLTIP"></icon>
				<p class="color-gray-light dz-text-11 dz-text-lg-12 padding-top-object-1" *ngIf="tableData[0]?.expenseRatioAsOfDate?.config?.label">
					{{ tableData[0]?.expenseRatioAsOfDate?.config?.label }} {{ dateFormatter.format(tableData[0]?.expenseRatioAsOfDate.formattedValue) }}
				</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="'ytdReturn'">
			<div [class]="headerWidth" class="no-padding riskProfileKeyHeader">
				<span dcrHTMLKey="GROSS_YTD_RETURN_HEADER">Gross YTD Return</span>
				<icon *ngIf="isAuthenticated" type="info-circle" class="info-circle" tooltip-dcr="HOLDINGS_YIELD_TOOLTIP"></icon>
				<p class="color-gray-light dz-text-11 dz-text-lg-12 padding-top-object-1" *ngIf="tableData[0]?.ytdReturnAsOfDate?.config?.label">
					{{ tableData[0]?.ytdReturnAsOfDate?.config?.label }} {{ dateFormatter.format(tableData[0]?.ytdReturnAsOfDate.formattedValue) }}
				</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="'customNetYearToDate'">
			<div *ngIf="isCustomNetAvailable" [class]="headerWidth" class="no-padding riskProfileKeyHeader">
				<p class="color-gray-light dz-text-12-condensed-light advisory-fee-label">
					<span dcrHTMLKey="CUSTOM_ADVISORY_FEE_LABEL">Advisory Fee</span> {{ customAdvisoryFee }}%
				</p>
				<span dcrHTMLKey="CUSTOM_NET_YTD_RETURN_HEADER">Net YTD Return</span>
				<icon *ngIf="isAuthenticated" type="info-circle" class="info-circle" tooltip-dcr="HOLDINGS_YIELD_CUSTOM_NET_TOOLTIP"></icon>
				<p class="color-gray-light dz-text-11 dz-text-lg-12 padding-top-object-1" *ngIf="tableData[0]?.ytdReturnAsOfDate?.config?.label">
					{{ tableData[0]?.ytdReturnAsOfDate?.config?.label }} {{ dateFormatter.format(tableData[0]?.ytdReturnAsOfDate.formattedValue) }}
				</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="'12mTrailingYield'">
			<div [class]="headerWidth" class="no-padding riskProfileKeyHeader">
				<span dcrHTMLKey="12M_TRAILING_YIELD_HEADER">12M Trailing Yield</span>
				<icon *ngIf="isAuthenticated" type="info-circle" class="info-circle" tooltip-dcr="HOLDINGS_TRAILING_YIELD_TOOLTIP"></icon>
				<p class="color-gray-light dz-text-11 dz-text-lg-12 padding-top-object-1" *ngIf="tableData[0]?.twelveMonthTrailingYieldAsOfDate?.config?.label">
					{{ tableData[0]?.twelveMonthTrailingYieldAsOfDate?.config?.label }}
					{{ dateFormatter.format(tableData[0]?.twelveMonthTrailingYieldAsOfDate.formattedValue) }}
				</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="'1YrReturn'">
			<div [class]="headerWidth" class="no-padding riskProfileKeyHeader">
				<span dcrHTMLKey="One_YEAR_RETURN_HEADER">1-Year Return</span>
				<icon *ngIf="isAuthenticated" type="info-circle" class="info-circle" tooltip-dcr="HOLDINGS_1YR_TOOLTIP"></icon>
				<p class="color-gray-light dz-text-11 dz-text-lg-12 padding-top-object-1" *ngIf="tableData[0]?.oneYrReturnAsOfDate?.config?.label">
					{{ tableData[0]?.oneYrReturnAsOfDate?.config?.label }} {{ dateFormatter.format(tableData[0]?.oneYrReturnAsOfDate.formattedValue) }}
				</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="'5YrReturn'">
			<div [class]="headerWidth" class="no-padding riskProfileKeyHeader">
				<span dcrHTMLKey="FIVE_YEAR_RETURN_HEADER">5-Year Return</span>
				<icon *ngIf="isAuthenticated" type="info-circle" class="info-circle" tooltip-dcr="HOLDINGS_5YR_TOOLTIP"></icon>
				<p class="color-gray-light dz-text-11 dz-text-lg-12 padding-top-object-1" *ngIf="tableData[0]?.fiveYrReturnAsOfDate?.config?.label">
					{{ tableData[0]?.fiveYrReturnAsOfDate?.config?.label }} {{ dateFormatter.format(tableData[0]?.fiveYrReturnAsOfDate.formattedValue) }}
				</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="'estimatedRisk'">
			<!-- TODO: Confirm if this is tooltip or dialog -->
			<div [class]="headerWidth" class="no-padding riskProfileKeyHeader">
				<span dcrHTMLKey="ESTIMATED_RISK_HEADER">Estimated Risk</span>
				<icon *ngIf="isAuthenticated" type="info-circle" class="info-circle" tooltip-dcr="HOLDINGS_EST_RISK_TOOLTIP"></icon>
				<p class="color-gray-light dz-text-11 dz-text-lg-12 padding-top-object-1" *ngIf="tableData[0]?.estimatedRiskAsOfDate?.config?.label">
					{{ tableData[0]?.estimatedRiskAsOfDate?.config?.label }} {{ dateFormatter.format(tableData[0]?.estimatedRiskAsOfDate.formattedValue) }}
				</p>
			</div>
		</ng-container>
	</ng-container>
</ng-template>
